// src/DualListBox.js

import React, { useEffect, useState } from 'react';
import './DualListBox.scss'; // For SCSS styling
import { faSearch, faAngleLeft, faAnglesLeft, faAngleRight, faAnglesRight, faAnglesUp, faAngleUp, faAngleDown, faAnglesDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const DualListBox = (props) => {
  const { items, onChange, initialData } = props
  const [availableItems, setAvailableItems] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [availableSearch, setAvailableSearch] = useState('');
  const [selectedSearch, setSelectedSearch] = useState('');
  const [selectedAvailable, setSelectedAvailable] = useState(null);
  const [selectedSelected, setSelectedSelected] = useState(null);

  useEffect(() => {
    setAvailableItems(items?.length ? items : [])
  }, [items])

  useEffect(() => {
      setSelectedItems(initialData?.length ? initialData : [])
  }, [initialData])

  const moveToSelected = (e) => {
    e.preventDefault();
    if (selectedAvailable) {
      const item = availableItems.find(i => i === selectedAvailable);
      setAvailableItems(availableItems.filter(i => i !== selectedAvailable));
      onChange([...selectedItems, item])
      setSelectedItems([...selectedItems, item]);
      setSelectedAvailable(null);
    }
  };

  const moveToAvailable = (e) => {
    e.preventDefault();
    if (selectedSelected) {
      const item = selectedItems.find(i => i === selectedSelected);
      const data = selectedItems.filter(i => i !== selectedSelected)
      setSelectedItems(data);
      onChange(data)
      setAvailableItems([...availableItems, item]);
      setSelectedSelected(null);
    }
  };

  const moveAllToSelected = (e) => {
    e.preventDefault();
    setSelectedItems([...selectedItems, ...availableItems]);
    onChange([...selectedItems, ...availableItems])
    setAvailableItems([]);
  };

  const moveAllToAvailable = (e) => {
    e.preventDefault();
    setAvailableItems([...availableItems, ...selectedItems]);
    onChange([])
    setSelectedItems([]);
  };

  const filteredAvailableItems
    = availableItems.filter(item =>
      item?.toLowerCase().includes(availableSearch?.toLowerCase())
    );

  const filteredSelectedItems = selectedItems?.filter(item =>
    item.toLowerCase().includes(selectedSearch?.toLowerCase())
  );

  return (
    <div className="dual-list-box">
      <div className="list">
        <h3 className='text-start'>{props?.listTitle}</h3>
        <div className='list-category'>
          <div className="search-input">
            <FontAwesomeIcon
              icon={faSearch}
              className="icon-magnifier mr-2"
            />
            <input
              type="text"
              placeholder="Search..."
              value={availableSearch}
              onChange={(e) => setAvailableSearch(e.target.value)}
            />
          </div>
          <ul>
            {filteredAvailableItems
              .map(item => (
                <li
                  key={item}
                  onClick={() => setSelectedAvailable(item)}
                  className={selectedAvailable === item ? 'selected' : ''}
                >
                  {/* <img src={item.logo} alt={item.name} /> */}
                  {item}
                </li>
              ))}
          </ul>
        </div>
      </div>

      <div className="arrows">
        <button onClick={moveAllToSelected}><FontAwesomeIcon icon={faAnglesRight} /></button>
        <button onClick={moveToSelected}><FontAwesomeIcon icon={faAngleRight} /></button>
        <button onClick={moveToAvailable}><FontAwesomeIcon icon={faAngleLeft} /></button>
        <button onClick={moveAllToAvailable}><FontAwesomeIcon icon={faAnglesLeft} /></button>
      </div>

      <div className="list">
        <h3 className='text-start'>{props?.selectedListTitle}</h3>
        <div className='list-category'>
          <div className="search-input">
            <FontAwesomeIcon
              icon={faSearch}
              className="icon-magnifier mr-2"
            />
            <input
              type="text"
              placeholder="Search..."
              value={selectedSearch}
              onChange={(e) => setSelectedSearch(e.target.value)}
            />
          </div>
          <ul>
            {filteredSelectedItems?.map(item => (
              <li
                key={item}
                onClick={() => setSelectedSelected(item)}
                className={selectedSelected === item ? 'selected' : ''}
              >
                {/* <img src={item?.logo} alt={item?.name} /> */}
                {item}
              </li>
            ))}
          </ul>
        </div>
        {props?.selectedHotelServiceMaxLengthError?.length>0&&<p className='required'>{props?.selectedHotelServiceMaxLengthError}</p>}
      </div>
    </div>
  );
};

export default DualListBox;
